import { axios } from '@/utils/request'
import { filterData } from '@/utils/util'

const api = {
  listhistory: `/blacklist/listhistory`,
  remove: `/blacklist/remove`,
  list: `/blacklist/list`
}

// 查看历史
export function listhistory (params) {
  return axios({
    url: api.listhistory,
    method: 'get',
    params: filterData(params),
    func:'查看历史'
  })
}

// 移除
export function removeItem (data) {
  return axios({
    url: api.remove,
    method: 'post',
    data: filterData(data),
    func:'移除'
  })
}

// 查询黑名单列表
export function queryList (params) {
  return axios({
    url: api.list,
    method: 'get',
    params: filterData(params),
    func:'查询黑名单列表'
  })
}
